import { ValidationType } from '../utils/validators';

import Field, { FieldDataType } from './Field';
import { Section } from './index';
import { ADDITIONAL_OCCUPANT } from '../constants';

export default class NonRefundableFeesSection extends Section {
  constructor(args) {
    super(args);

    this.setIndexedFieldTypes([
      new Field({
        fieldName: ADDITIONAL_OCCUPANT.FIELD_NAME.IS_ENABLED,
        dataType: FieldDataType.boolean,
        enteredValue: true,
        validation: ValidationType.BooleanValidator,
      }),
      new Field({
        fieldName: ADDITIONAL_OCCUPANT.FIELD_NAME.FIRST_NAME,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: null,
      }),
      new Field({
        fieldName: ADDITIONAL_OCCUPANT.FIELD_NAME.LAST_NAME,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: null,
      }),
      new Field({
        fieldName: ADDITIONAL_OCCUPANT.FIELD_NAME.AGE,
        enteredValue: '',
        dataType: FieldDataType.number,
        validation: ValidationType.PositiveIntegerValidator,
      }),
      new Field({
        fieldName: ADDITIONAL_OCCUPANT.FIELD_NAME.BIRTH_DATE,
        enteredValue: '',
        dataType: FieldDataType.date,
        validation: null,
      }),
    ]);
  }
}
